import { Grid, Typography } from '@mui/material';
import SelectTimezone from '../forms/helpers/SelectTimezone';

type Props = {
    timezone: string;
    setTimezone: (timezone: string) => void;
};

const ProfileDialogAccount = (props: Props) => {
    const { timezone, setTimezone } = props;

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item xs={12}>
                <Typography variant="h6">Account Settings</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="body2" color="text.secondary">
                    Select your default time zone. This will be used as the default for reports, scheduling, and other time-sensitive
                    features.
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <SelectTimezone timezone={timezone} setTimezone={setTimezone} fullWidth />
            </Grid>
        </Grid>
    );
};

export default ProfileDialogAccount;
